import DataDisplayRowI from "../DataDisplayRowI";
import getPCComponentIncompleteRow from "../DataDisplayRow/PCComponentIncompleteRow";
import DataDisplayTable from "../DataDisplayTable";

class PCComponentIncompleteTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getPCComponentIncompleteRow()
    }
}

let pcComponentIncompleteTable: PCComponentIncompleteTable | null = null;

export default function getPCComponentIncompleteTable(): PCComponentIncompleteTable {
    if (pcComponentIncompleteTable === null)
        pcComponentIncompleteTable = new PCComponentIncompleteTable()
    return pcComponentIncompleteTable
}